export const fadeInWhileInViewSnippet = {
  viewport: { once: true, amount: 0.17 },
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 1, ease: 'easeInOut' }
} as const